/** Formattazione italiana in un posto solo: le griglie devono essere coerenti tra loro. */

/*  `useGrouping: 'always'` non è un vezzo. La convenzione italiana di CLDR raggruppa solo
    da cinque cifre in su, quindi senza questa opzione la stessa colonna mostra «6200,00 €»
    e «31.000,00 €» una sotto l'altra: le migliaia si vedono su un numero e non sull'altro,
    e in una colonna di importi allineati a destra è il modo più rapido di leggere un
    ordine di grandezza sbagliato. Nei gestionali italiani il separatore c'è sempre.  */
const numero = new Intl.NumberFormat('it-IT', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: 'always',
});
const interi = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2, useGrouping: 'always' });
const valuta = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  useGrouping: 'always',
});
const data = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });

/*  Data e ora insieme, per il registro delle modifiche: là la sola data non basta, perché
    di modifiche allo stesso documento nello stesso giorno ce ne sono diverse e l'ordine
    fra loro è tutto quello che si sta cercando. I secondi ci sono per la stessa ragione:
    due salvataggi consecutivi stanno nello stesso minuto.  */
const dataOra = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

/*  «Non lo so» non si scrive «0,00 €».

    `Number(null)` e `Number('')` valgono zero, quindi passando un campo nullo a queste
    funzioni usciva un importo pieno: le trasferte di una commessa, che non si registrano
    e arrivano NULL, sarebbero apparse come «zero speso». Una percentuale senza base
    (budget a zero) lo stesso. Zero invece è un valore e si scrive: la differenza fra i
    due casi la fa questo controllo, non `Number.isFinite`.

    Vale per i valori che arrivano dall'API. I numeri scritti a mano hanno un'altra
    funzione, `lib/numeri.ts`, che accetta la virgola e fa la stessa distinzione.  */
function numerico(valore: unknown): number | null {
  if (valore === null || valore === undefined || valore === '') return null;
  const n = Number(valore);
  return Number.isFinite(n) ? n : null;
}

export function formattaImporto(valore: unknown): string {
  const n = numerico(valore);
  return n === null ? '' : valuta.format(n);
}

export function formattaNumero(valore: unknown): string {
  const n = numerico(valore);
  return n === null ? '' : interi.format(n);
}

export function formattaPercentuale(valore: unknown): string {
  const n = numerico(valore);
  return n === null ? '' : `${numero.format(n)}%`;
}

export function formattaData(valore: unknown): string {
  if (valore === null || valore === undefined || valore === '') return '';
  const d = new Date(String(valore));
  return Number.isNaN(d.getTime()) ? '' : data.format(d);
}

export function formattaDataOra(valore: unknown): string {
  if (valore === null || valore === undefined || valore === '') return '';
  const d = new Date(String(valore));
  return Number.isNaN(d.getTime()) ? '' : dataOra.format(d);
}

/** Le date verso l'API viaggiano in ISO: il parsing lato server è esatto, non locale. */
export function isoDaInput(valore: string): string | null {
  return /^\d{4}-\d{2}-\d{2}$/.test(valore) ? valore : null;
}

export function oggiIso(): string {
  const d = new Date();
  const mese = String(d.getMonth() + 1).padStart(2, '0');
  const giorno = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mese}-${giorno}`;
}
